"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Tooltip: function() {
        return _index.Tooltip;
    },
    renderTooltip_unstable: function() {
        return _index.renderTooltip_unstable;
    },
    tooltipClassNames: function() {
        return _index.tooltipClassNames;
    },
    useTooltipStyles_unstable: function() {
        return _index.useTooltipStyles_unstable;
    },
    useTooltip_unstable: function() {
        return _index.useTooltip_unstable;
    }
});
const _index = require("./components/Tooltip/index");
